import { FirebaseError } from "firebase/app";
import {
  ConfirmationResult,
  FacebookAuthProvider,
  RecaptchaVerifier,
  linkWithRedirect,
  signInWithRedirect,
  signInWithCredential,
  signInWithPhoneNumber,
} from "firebase/auth";
import { auth } from "../firebase";

export const facebookSignIn = async () => {
  const facebookProvider = new FacebookAuthProvider();

  if (auth.currentUser?.isAnonymous) {
    return linkWithRedirect(auth.currentUser, facebookProvider);
  } else {
    return signInWithRedirect(auth, facebookProvider);
  }
};

export const handleFacebookError = async (err: any) => {
  if (
    err.code === "auth/credential-already-in-use" ||
    err.code === "auth/account-exists-with-different-credential"
  ) {
    const pendingCred = err.credential;
    auth
      .signOut()
      .then(() => {
        return signInWithCredential(auth, pendingCred);
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  } else {
    alert(err.message);
  }
};

/**
 * Sends the SMS code. Each send builds its own invisible reCAPTCHA in a fresh
 * element inside the calling form's `container` and tears it down after —
 * nothing shared between forms (pages mount several: Signup has the verify
 * modal and the login modal), nothing to reset between a send and a resend,
 * and reCAPTCHA never renders twice into one element. Keep the returned
 * ConfirmationResult in the form and pass it to `phoneSignInConfirm`.
 */
export const phoneSignInSendSMS = async (
  phoneNumber: string,
  container: HTMLElement | null,
): Promise<ConfirmationResult> => {
  if (!container) {
    throw new FirebaseError("auth/argument-error", "No reCAPTCHA container");
  }
  const host = document.createElement("div");
  container.appendChild(host);
  const verifier = new RecaptchaVerifier(auth, host, { size: "invisible" });
  try {
    return await signInWithPhoneNumber(auth, phoneNumber, verifier);
  } finally {
    verifier.clear();
    host.remove();
  }
};

export const phoneSignInConfirm = async (
  confirmation: ConfirmationResult | null,
  OTP: string,
) => {
  if (!confirmation) {
    throw new Error(
      "No verification session found. Please request a new code.",
    );
  }
  return confirmation.confirm(OTP);
};
